// extracted by mini-css-extract-plugin
export var deleteIcon = "_nr-5";
export var deleteOption = "_nr-3";
export var divider = "_nr-2";
export var downloadIcon = "_nr-4";
export var drawer = "_nr-0";
export var drawerFooter = "_nr-6";
export var drawerOpen = "_nr-1";
export var highlighted = "_nr-7";
export var lighterHighlight = "_nr-8";